module.exports = __webpack_public_path__ + "static/media/bell-agogo2.4f1f8599.aac";